import _ from 'lodash'

/**
 * Given a tree or hash of nodes by id and an id of a node to start from, returns true if the function given
 * resolves to true for any of the node's ancestors.
 *
 * @param {Object} tree - Either a kalpa tree or hash of objects by node id
 * @param {Integer} id - The id of the node to start checking from
 * @param {Function} fun - the function call on each parent, if true evaluation stop immediately
 */
function treeSomeAncestors(tree, id, fun) {
	if (!tree) return
	let node = tree.get ? tree.get(id) : tree[id]
	if (!node) return
	let parent = _.result(node, 'parent')
	if (_.isFunction(tree.parent)) {
		parent = tree.parent(node)
	}
	if (!parent) return
	if (!fun(parent)) {
		return treeSomeAncestors(tree, parent.id, fun)
	}
	return true
}

export default treeSomeAncestors
treeSomeAncestors.__filename__ = 'components/tree-some-ancestors.js'
